import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
import { memo } from 'react';
const VaultsListSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="p-sm flex max-h-[200px] flex-col overflow-auto">{Array.from({
        length: 4
      }).map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(VaultsListSkeleton);
function _temp(_, index) {
  return <div className="px-xs py-2xs flex w-full cursor-pointer items-center rounded-lg" key={index}><Skeleton className="h-[21px] w-[100%] rounded-[20px]" key={index} /></div>;
}